import React, { useMemo, useState } from 'react'
import classNames from 'classnames'
import useToggle from 'hooks/useToggle'
import { useSelector } from 'react-redux'

const Accordian = ({ isDrawerOpen, list, handleClick, isOpened, notFoundLabel = 'Not found' }) => {
  const [activeItem, setActiveItem] = useState('')
  const getToggleKeys = useMemo(() => {
    let arr = []
    list.forEach((element) => {
      arr.push(element.id)
    })
    return arr
  }, [list])
  const [isOpen, handleToggle] = useToggle(getToggleKeys, isOpened ? 'multi' : 'single', isOpened)
  const { activeChatTheme } = useSelector((state) => state.theme)

  return (
    <div className="accordian-section mb-0">
      {list.map((d) => {
        const { id, title, icon, children } = d
        return (
          <div key={id + 'accordian'}>
            <div
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                children ? (handleToggle(id), setActiveItem(id)) : handleClick(d, d.id)
              }}
              data-id={d.id}
              className={classNames(
                'parent-section cursor-pointer flex align-center justify-between py-1.5 px-0 rounded',
                activeChatTheme
              )}
            >
              <div
                className={classNames(
                  'left-side-container relative flex gap-2',
                  { 'pl-[15px]': isDrawerOpen, 'pl-0': !isDrawerOpen },
                  'rounded',
                  { active: activeItem === id }
                )}
              >
                <div className={'icon-contianer'}>{icon}</div>
                {isDrawerOpen && (
                  <div className={'title hover:text-black  text-sm font-bold text-gray-300'}>{title}</div>
                )}
              </div>
            </div>
            {children && (
              <div
                className={classNames('child-section cursor-pointer', {
                  hidden: !isOpen[id],
                  visible: isOpen[id],
                })}
              >
                {children.map((item) => {
                  return (
                    <div
                      onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        handleClick(item, item.id)
                      }}
                      data-id={item.id}
                      className={classNames(
                        'list-item !pl-8 p-2 font-medium text-sm',
                        activeChatTheme != 'theme5' ? 'text-white' : '',
                        {
                          active: activeItem === item.id,
                        }
                      )}
                      key={item.id}
                    >
                      {item.title}
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        )
      })}
      {!list.length && isDrawerOpen && (
        <div className="not-found flex justify-center text-base align-center text-center font-bold">
          {notFoundLabel}
        </div>
      )}
    </div>
  )
}

export default Accordian
